import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface SortableHeaderProps {
  title: string;
  canSort?: boolean;
  isSorted?: false | "asc" | "desc";
  onSort?: () => void;
  className?: string;
}

export function SortableHeader({ 
  title, 
  canSort = true, 
  isSorted, 
  onSort,
  className 
}: SortableHeaderProps) {
  if (!canSort) {
    return <div className={className}>{title}</div>;
  }

  const SortIcon = isSorted === "asc" ? ArrowUp : isSorted === "desc" ? ArrowDown : ArrowUpDown;
  const sortLabel = isSorted === "asc" ? "Sorted ascending" : isSorted === "desc" ? "Sorted descending" : "Sort column";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          onClick={onSort}
          className={cn("h-8 px-2 lg:px-3", className)}
          aria-label={`${sortLabel}: ${title}`}
        >
          {title}
          <SortIcon className="ml-2 h-4 w-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{sortLabel}</TooltipContent>
    </Tooltip>
  );
}